import { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../store/loader';
import { Button, Chip } from '@mui/material';
import { useDoctorService } from '../../../../hooks';
import { Doctor } from '../../../../../domain/entities';
import { Days } from '../../../../../utils/dates';

interface Props {
  doctor: Doctor;
}

const PickDoctorSchedule = ({ doctor }: Props) => {
  const DoctorService = useDoctorService();
  const dispatch = useDispatch();
  const [availableDays, setAvailableDays] = useState<number[]>([]);

  const isLoading = (state: boolean) => dispatch(loaderActions.setLoading(state));

  useEffect(() => {
    const numberDaysArray = doctor.availableDays.map((date) => date.getDay());
    const numberDaysSet = numberDaysArray.filter((day, index) => {
      return numberDaysArray.indexOf(day) === index;
    });
    setAvailableDays(numberDaysSet);
  }, []);

  const isSelectedDay = (day: number) => {
    return availableDays.includes(day);
  };

  const handleDayClicked = (day: number) => {
    if (availableDays.includes(day)) {
      const newAvailableDays = availableDays.filter((availableDay) => availableDay !== day);
      setAvailableDays(newAvailableDays);
    } else {
      setAvailableDays([...availableDays, day]);
    }
  };

  const saveAvailableDays = () => {
    isLoading(true);

    DoctorService.updateAvailableDays(doctor.id, availableDays)
      .catch((e) => console.log(e))
      .finally(() => isLoading(false));
  };

  return (
    <div className={styles.container}>
      <div className={styles['doctor-name']}>
        {`${doctor.name} / `}
        <span className={styles['doctor-specialty']} style={{ color: doctor.specialty.color }}>
          {doctor.specialty.name}
        </span>
      </div>
      <div className={styles['select-days']}>Seleccionar días:</div>
      <div>
        {Days.map((day, index) => (
          <Chip
            key={index}
            sx={{ m: 1, minWidth: '85px' }}
            color='primary'
            variant={isSelectedDay(index) ? 'filled' : 'outlined'}
            label={day}
            onClick={() => handleDayClicked(index)}
          />
        ))}
      </div>
      <Button
        sx={{ marginTop: '10px', paddingX: '16px', paddingY: '4px' }}
        color='error'
        variant='contained'
        size='small'
        onClick={saveAvailableDays}
      >
        Guardar
      </Button>
    </div>
  );
};

export default PickDoctorSchedule;
